module.exports = __webpack_public_path__ + "static/formula-18f4c49c0c09e182ead1b950e6c7ae47.png";